<template>
  <custom-dialog
    icon="mdi-information-variant"
    color="info"
    :title="active && active.property && active.property.name"
    @close="handleCloseClick"
    boilerplate
    v-resize="onResize"
  >
    <template v-slot:actions>
      <request-actions
        v-if="active && active.id && isHISDisabled(active)"
        :assigned="active.dispatched === 'O'"
        :entity_nav_full_id="active.entity_nav_full_id"
        :entityOrdo="active.entity_ordo === 'O'"
        :groupId="active.group_id"
        :item="active"
        :paused="isActivePaused === 'O'"
        :property-id="active.property_id"
        :qualification="active.work_order_group_qualif_code"
        :rejected="active.rejected === 'O'"
        :requestId="active.id"
        :requestOrdo="active.property.request_ordo === 'O'"
        :status="active.status"
        :symptom="active.work_order_group_type_code"
        :technician_internal_id="active.technician_internal_id"
        :TPEM="active.his_treatment === 'Traitement PEM'"
      >
        <link-to-cofely-vision
          v-if="property.m2m_remotemanagement_enabled"
          has-label
          :numins="property.id"
          :region="property.entity_region"
        />
      </request-actions>
      <link-to-cofely-vision
        v-else-if="active && active.id && property.m2m_remotemanagement_enabled"
        class="mr-3"
        :numins="property.id"
        :region="property.entity_region"
      />
    </template>
    <div class="d-flex " :class="stateClass" style="height: 100%">
      <div class="d-flex elevation-5 left-side">
        <request-left-side
          v-show="sidePanelIsOpen"
          @requestLogsOpen="handleLeftSideWidthChange"
          class="overflow-y-auto overflow-x-hidden"
          :style="{ height: height + 'px' }"
        />
        <div :style="{ height: height + 'px' }" class="d-flex align-center">
          <div class="primary menu-bar" />
          <v-btn
            style="position: relative; left: 11px"
            @click="handleToggleLeftPanel"
            icon
            class="primary"
            small
          >
            <v-icon color="background">
              {{ sidePanelIsOpen ? 'navigate_before' : 'navigate_next' }}
            </v-icon>
          </v-btn>
        </div>
      </div>
      <div style="position: relative" class="pl-3 right-side">
        <request-right-side />
      </div>
    </div>
  </custom-dialog>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from 'vuex';
import RequestLeftSide from '@/pages/eDispatch/requestDetails/leftSide/RequestLeftSide';
import { generateMessage } from '@/utils/i18n';
import CustomDialog from '@/components/dialogs/CustomDialog';
import RequestRightSide from '@/pages/eDispatch/requestDetails/rightSide/RequestRightSide';
import resizable from '@/business/mixins/resizable';
import {
  POPUP_BOTTOM_HEIGHT,
  POPUP_TOP_HEIGHT,
} from '@/components/dialogs/customDialog.styles';
import LinkToCofelyVision from '@/components/tools/LinkToCofelyVision';
import RequestActions from '@/pages/eDispatch/requestsTable/RequestActions';
import isHISDisabled from '@/pages/eDispatch/rules/HIS';

const { mapActions } = createNamespacedHelpers('requests');

export default {
  name: 'requests-dialog',
  mixins: [resizable],
  components: {
    LinkToCofelyVision,
    RequestRightSide,
    CustomDialog,
    RequestLeftSide,
    RequestActions,
  },
  computed: {
    ...mapGetters({
      active: 'requests/active',
      isActiveLoading: 'requests/isActiveLoading',
      isActivePaused: 'requests/isActivePaused',
      property: 'properties_360/current',
      dispatched: 'requests/dispatched/items',
    }),
    height() {
      return (
        this.boilerplatePopupHeight - POPUP_TOP_HEIGHT - POPUP_BOTTOM_HEIGHT
      );
    },
    stateClass() {
      if (this.sidePanelIsOpen) {
        return this.requestLogsOpen ? 'left-open' : 'left-middle-open';
      }
      return 'left-close';
    },
    groupId() {
      return (
        this.dispatched.find((item) => item.request_id === this.active.id) &&
        this.dispatched.find((item) => item.request_id === this.active.id)
          .group_id
      );
    },
  },
  data() {
    return {
      sidePanelIsOpen: true,
      requestLogsOpen: false,
    };
  },
  methods: {
    ...mapActions(['removeCurrent']),
    generateMessage,
    isHISDisabled,
    handleCloseClick() {
      this.removeCurrent(this.active.id);
    },
    handleToggleLeftPanel() {
      this.sidePanelIsOpen = !this.sidePanelIsOpen;
    },
    handleLeftSideWidthChange(val) {
      this.requestLogsOpen = val;
    },
  },
};
</script>

<style scoped>
.left-open .right-side {
  position: relative;
  width: 50%;
}

.left-open .left-side {
  width: 50%;
}

.left-middle-open .right-side {
  position: relative;
  width: 75%;
}

.left-middle-open .left-side {
  width: 25%;
}

.left-close .right-side {
  width: calc(100% - 34px);
  position: relative;
}

.left-close .left-side {
  width: 34px;
}

.menu-bar {
  position: relative;
  width: 6px;
  height: 50%;
  left: 29px;
}
</style>
